import { gql } from '@apollo/client';

export const QUERY = gql`
  query FormAdjustmentDefinitions($organizationId: Int!) {
    formAdjustmentDefinitions(organizationId: $organizationId) {
      active
      amount
      category
      id
      maxAmount
      name
      type
    }
  }
`;
